@use "@fukuri-admins/ui/layout" as *;

.SubMenuList {
  width: 220px;
  position: absolute;
  top: 0;
  left: 100%;
  background-color: $transparentDark;
  border-radius: 8px;
  display: none;
  padding: 16px;

  &__Subitem {
    padding: 8px;
    display: block;
    width: 100%;
    transition: all 0.2s ease-out;
    text-decoration: none;

    &:hover {
      background-color: $NATURAL_500;
      border-radius: 4px;
    }

    &__Content {
      color: $White;
      font-size: 16px;
      font-weight: 600;
    }
  }
}
